export const parseString = (dataString) => {
  try {
    // Check if item is already an object or needs parsing
    return typeof dataString === 'string' ? JSON.parse(dataString) : dataString;
  } catch (error) {
    console.error('Error parsing item:', error);
    return {};
  }
};
